import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=7cd12ea0&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=ts&"
export * from "./page2.vue?vue&type=script&lang=ts&"
import style0 from "./page2.vue?vue&type=style&index=0&id=7cd12ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd12ea0",
  null
  
)

export default component.exports